import slice from './reducer'
import emailRecipientsSaga from './sagas'

export const {
  fetchRequest: fetchRecipientsRequest,
  fetchSuccess: fetchRecipientsSuccess,
  fetchError: fetchEmailRecipientsError,
  setFilters: setRecipientsFilters,
  reset: resetRecipients,
  resetListedRecipients,
  resetObjectAndMetersFilter,
  onRecipientsClose,
  addRecipient,
  removeRecipient,
  addRecipientToRemovalQueue,
  removeRecipientFromRemovalQueue,
  addRecipientsToRemovalQueue,
  removeRecipientsFromRemovalQueue,
  addAllRecipients,
  removeAllRecipients,
  handleSubmitEmail: handleSubmitEmailRecipients,
  handleSubmitSms: handleSubmitSmsRecipients,
  handleRecipientModal,
  fetchClientAddressesRequest: fetchRecipientsClientAddressesRequest,
  fetchClientAddressesSuccess: fetchRecipientsClientAddressesSuccess,
  fetchClientAddressesError: fetchRecipientsClientAddressesError,
  fetchBuildingTypesRequest: fetchRecipientsBuildingTypesRequest,
  fetchBuildingTypesSuccess: fetchRecipientsBuildingTypesSuccess,
  fetchBuildingTypesError: fetchRecipientsBuildingTypesError,
  fetchCommmitteesRequest: fetchRecipientsCommitteesRequest,
  fetchCommmitteesSuccess: fetchRecipientsCommitteesSuccess,
  fetchCommmitteesError: fetchRecipientsCommitteesError,
  fetchObjectAndMetersTypesRequest: fetchRecipientsObjectAndMetersTypesRequest,
  fetchObjectAndMetersTypesSuccess: fetchRecipientsObjectAndMetersTypesSuccess,
  fetchObjectAndMetersTypesError: fetchRecipientsObjectAndMetersTypesError,
  fetchFrequentEmailRecipientsRequest,
  fetchFrequentEmailRecipientsSuccess,
  fetchFrequentEmailRecipientsError,
  fetchFrequentSmsRecipientsRequest,
  fetchFrequentSmsRecipientsSuccess,
  fetchFrequentSmsRecipientsError,
  resetFilters: resetRecipientsFilters,
} = slice.actions

export default slice.reducer
export { emailRecipientsSaga }
